import { useState, useCallback, Dispatch, SetStateAction } from 'react';

export type UseToggleState = (
  initialState?: boolean,
) => readonly [boolean, () => void, Dispatch<SetStateAction<boolean>>];

export const useToggleState: UseToggleState = (initialState = false) => {
  const [state, setState] = useState<boolean>(initialState);
  const toggleState = useCallback<() => void>(() => setState(st => !st), [setState]);

  return [state, toggleState, setState] as const;
};
